if (!customElements.get('bd-slideshow')) {
  customElements.define('bd-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = [...this.querySelectorAll('.bd-slide')];
      this.index = 0;
      this.play = this.querySelector('[data-play]');
      this.status = this.querySelector('[data-status]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.querySelector('.bd-slide-controls').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1, true), {signal});
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1, true), {signal});
      this.play.addEventListener('click', () => {this.paused = !this.paused; this.sync();}, {signal});
      document.addEventListener('visibilitychange', () => this.sync(), {signal});
      this.reduced.addEventListener('change', () => {if(this.reduced.matches) this.paused = true; this.sync();}, {signal});
      this.querySelector('.bd-slides').addEventListener('touchstart', e => {this.touch = [e.changedTouches[0].clientX,e.changedTouches[0].clientY];}, {passive:true,signal});
      this.querySelector('.bd-slides').addEventListener('touchend', e => {
        if(!this.touch) return;
        const dx=e.changedTouches[0].clientX-this.touch[0],dy=e.changedTouches[0].clientY-this.touch[1];
        if(Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)) this.move(dx<0?1:-1,true);
        this.touch=null;
      }, {passive:true,signal});
      this.sync();
    }
    move(delta, manual=false) {
      this.index=(this.index+delta+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i) => {slide.hidden=i!==this.index;});
      this.status.textContent=`${this.index+1} / ${this.slides.length} · ${this.slides[this.index].dataset.name}`;
      this.sync();
    }
    sync() {
      clearInterval(this.timer);
      this.play.textContent=this.paused?'Play':'Pause';
      this.play.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');
      this.status.setAttribute('aria-live',this.paused?'polite':'off');
      if(!this.paused && !document.hidden) this.timer=setInterval(() => this.move(1),5000);
    }
    disconnectedCallback() {clearInterval(this.timer);this.abort.abort();}
  });
}
